import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { styled } from "@mui/material";
import { useEffect, useState } from "react";
import { IListItem } from "../../interface/list-item";
import { ITreeItem } from "../../interface/tree-item";
import { IWithClassName, IWithThemeProps } from "../../theme/default.theme";
import DrawNodeOptions from "./draw-node-options";

interface IOwnProps {
    selectedIds: Set<string>;
    node: ITreeItem;
    forceExpand?: boolean;
    onChange: (items: Array<IListItem>, isChecked: boolean) => void;
}

const DrawNode = ({
    node,
    selectedIds,
    forceExpand,
    onChange,
    className,
}: IOwnProps & IWithClassName) => {
    const [isExpanded, setExpanded] = useState(!!forceExpand);

    useEffect(() => {
        setExpanded(!!forceExpand);
    }, [forceExpand]);

    const handleExpandClick = () => {
        setExpanded((prevValue) => !prevValue);
    };

    const handleParentNodeChange = (isChecked: boolean) => {
        if (node.children) {
            onChange(
                node.children.filter(
                    (child) => isChecked !== selectedIds.has(child.id),
                ),
                isChecked,
            );
        }
    };

    const isSelected = node.children?.every((item) => selectedIds.has(item.id));
    const isIndeterminate =
        node.children?.some((item) => selectedIds.has(item.id)) && !isSelected;

    return (
        <div className={className}>
            <div className="parent-node">
                <DrawNodeOptions
                    option={node}
                    isChecked={isSelected}
                    isIndeterminate={isIndeterminate}
                    onChange={(_, checked) => handleParentNodeChange(checked)}
                />
                <div className="arrow-container">
                    {isExpanded ? (
                        <ExpandLess onClick={handleExpandClick} />
                    ) : (
                        <ExpandMore onClick={handleExpandClick} />
                    )}
                </div>
            </div>
            {isExpanded ? (
                <div className="child-nodes">
                    {node?.children?.map((child) => (
                        <DrawNodeOptions
                            option={child}
                            isChecked={selectedIds.has(child.id)}
                            key={child.id}
                            onChange={onChange}
                        />
                    ))}
                </div>
            ) : (
                <></>
            )}
        </div>
    );
};

export default styled(DrawNode)(({ theme }: IWithThemeProps) => ({
    ".child-nodes": {
        paddingLeft: theme?.spacing(3),
    },
    ".parent-node": {
        display: "flex",
    },
    ".arrow-container": {
        marginTop: "auto",
        marginBottom: "auto",
        marginLeft: "auto",
    },
}));
